export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <span className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">
                每日大赛黑料
              </span>
              <p className="mt-4 text-sm text-background-400 leading-relaxed max-w-xs">
                每日大赛黑料吃瓜专区，提供大赛吃瓜、黑料吃瓜群、每日吃瓜爆料等八卦内容，大赛八卦与黑料围观，黑料吃瓜每日黑料最新，大赛内幕深度挖掘，满足吃瓜群众。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <nav className="flex flex-col gap-2.5">
                <a href="#updates" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">最新快讯</a>
                <a href="#ranking" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">热度榜单</a>
                <a href="#index" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">专题合集</a>
                <a href="#faq" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
              </nav>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">热门话题</h4>
              <nav className="flex flex-col gap-2.5">
                <a href="#topics" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">大赛吃瓜</a>
                <a href="#topics" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">黑料吃瓜群</a>
                <a href="#topics" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">每日吃瓜爆料</a>
                <a href="#topics" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">大赛内幕</a>
              </nav>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
              <p className="text-sm text-background-500">诚邀各大平台及媒体合作，共同打造大赛黑料吃瓜生态。</p>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 每日大赛黑料. 本网站内容仅供娱乐参考，不构成任何建议。
            </p>
            <div className="flex items-center gap-4">
              <a href="#contact" className="text-xs text-background-500 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
              <a href="#about" className="text-xs text-background-500 hover:text-background-200 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}